import { useCallback, useMemo, useState } from 'react';
import useColumnsPreferenceActions from '../../../hooks/useColumnsPreferenceActions';
import { valueMatchWithQuery } from '../../../utils/string';
import { UseSavableHideableColumnsVisibilityProps } from './useSavableHideableColumnsVisibility.types';

const useSavableHideableColumnsVisibility = ({
  list,
  columns,
}: UseSavableHideableColumnsVisibilityProps) => {
  const [textValue, setTextValue] = useState('');

  const changeTextValue = useCallback((value: string) => setTextValue(value), []);

  const filteredColumns = useMemo(() => {
    const visibleColumns = columns.filter((option) => valueMatchWithQuery(option.name, textValue));
    return visibleColumns;
  }, [textValue, columns]);

  const visibleColumnKeys = columns
    .filter((column) => column.isVisible)
    .map((column) => column.key);

  const { canSaveColumns, canRestoreToDefaultColumns, isSavingColumns, saveColumns } =
    useColumnsPreferenceActions({ list, visibleColumnKeys });

  return {
    textValue,
    changeTextValue,
    filteredColumns,
    saveColumns,
    isSavingColumns,
    canSaveColumns,
    canRestoreToDefaultColumns,
  };
};

export default useSavableHideableColumnsVisibility;
